// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.complete-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif;
}

.complete-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  background: linear-gradient(
    135deg,
    #0a0a1a 0%,
    #1a0a2e 25%,
    #16213e 50%,
    #0f3460 75%,
    #1a0a2e 100%
  );
  background-size: 400% 400%;
  animation: complete-gradient-shift 12s ease infinite;
}

@keyframes complete-gradient-shift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.complete-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 50% 0%, rgba(255, 215, 0, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse 60% 40% at 20% 80%, rgba(255, 105, 180, 0.12) 0%, transparent 45%),
    radial-gradient(ellipse 60% 40% at 80% 70%, rgba(0, 191, 255, 0.12) 0%, transparent 45%);
  animation: complete-glow-pulse 4s ease-in-out infinite;
}

@keyframes complete-glow-pulse {
  0%,
  100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

.complete-stars {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}

.complete-star {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #fff;
  border-radius: 50%;
  animation: complete-star-twinkle 2s ease-in-out infinite;
  box-shadow: 0 0 6px #fff;
}

@keyframes complete-star-twinkle {
  0%,
  100% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.complete-canvas {
  position: fixed;
  inset: 0;
  z-index: 2;
  pointer-events: none;
}

.complete-confetti-layer {
  position: fixed;
  inset: 0;
  z-index: 3;
  pointer-events: none;
  overflow: hidden;
}

.complete-confetti {
  position: absolute;
  top: -10%;
  opacity: 0.9;
  animation: complete-confetti-fall linear forwards;
}

@keyframes complete-confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(110vh) rotate(720deg);
    opacity: 0.6;
  }
}

.complete-content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 1.5rem;
  max-width: 900px;
  width: 100%;
}

.complete-logo-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 1.25rem;
  padding: 0.5rem;
  animation: complete-logo-float 3.5s ease-in-out infinite;
}

.complete-logo-wrap::before {
  content: "";
  position: absolute;
  inset: -12%;
  background: radial-gradient(
    ellipse at center,
    rgba(255, 215, 0, 0.12) 0%,
    rgba(0, 212, 255, 0.06) 40%,
    transparent 70%
  );
  pointer-events: none;
  z-index: -1;
}

.complete-logo {
  display: block;
  width: clamp(180px, 42vw, 280px);
  height: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: center;
  image-rendering: auto;
  backface-visibility: hidden;
  transform: translateZ(0);
  filter: drop-shadow(0 12px 40px rgba(0, 0, 0, 0.45))
    drop-shadow(0 0 48px rgba(255, 215, 0, 0.25))
    drop-shadow(0 0 24px rgba(0, 212, 255, 0.15));
}

@keyframes complete-logo-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.complete-title {
  margin: 0 0 1rem;
  font-size: clamp(1.5rem, 5.5vw, 3rem);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.02em;
  background: linear-gradient(
    90deg,
    #ffd700,
    #fff8dc,
    #ff6b9d,
    #00d4ff,
    #ffd700
  );
  background-size: 300% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: complete-title-shine 4s linear infinite;
  text-shadow: none;
  filter: drop-shadow(0 0 30px rgba(255, 215, 0, 0.4));
}

@keyframes complete-title-shine {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 300% center;
  }
}

.complete-subtitle {
  margin: 0 0 2rem;
  font-size: clamp(1rem, 3vw, 1.35rem);
  color: rgba(255, 255, 255, 0.85);
  font-weight: 400;
  line-height: 1.6;
  animation: complete-fade-up 1s ease 0.3s both;
}

.complete-badge-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  animation: complete-fade-up 1s ease 0.6s both;
}

.complete-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1.35rem;
  border-radius: 999px;
  font-size: clamp(0.8rem, 2.5vw, 0.95rem);
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.08);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.complete-badge::before {
  content: "";
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 10px currentColor;
}

.complete-badge--gold {
  color: #ffd700;
  border-color: rgba(255, 215, 0, 0.5);
  background: rgba(255, 215, 0, 0.12);
}

.complete-badge--pink {
  color: #ff6b9d;
  border-color: rgba(255, 105, 180, 0.5);
  background: rgba(255, 105, 180, 0.12);
}

.complete-badge--cyan {
  color: #00d4ff;
  border-color: rgba(0, 212, 255, 0.5);
  background: rgba(0, 212, 255, 0.12);
}

.complete-sparkle-ring {
  position: absolute;
  width: min(90vw, 500px);
  height: min(90vw, 500px);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 2px solid transparent;
  background: linear-gradient(45deg, transparent, rgba(255, 215, 0, 0.2), transparent) border-box;
  mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  animation: complete-ring-spin 8s linear infinite;
  pointer-events: none;
  z-index: -1;
}

@keyframes complete-ring-spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes complete-fade-up {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .complete-content {
    padding: 1rem;
  }

  .complete-badge-row {
    gap: 0.5rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .complete-bg,
  .complete-bg::before,
  .complete-title,
  .complete-logo-wrap,
  .complete-star,
  .complete-confetti,
  .complete-sparkle-ring {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/complete/Complete.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sEAAsE;AACxE;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV;;;;;;;GAOC;EACD,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;4FAG0F;EAC1F,sDAAsD;AACxD;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX;;;;;GAKC;EACD,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EAErB,2BAA2B;EAC3B,wBAAwB;EACxB;;iDAE+C;AACjD;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kDAAkD;EAClD,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,2CAA2C;EAC3C,qCAAqC;EACrC,kCAA0B;UAA1B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,+FAA+F;EAE/F,sEAAsE;EAEtE,uBAAuB;EACvB,gDAAgD;EAChD,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;;;;;;IAOE,eAAe;EACjB;AACF","sourcesContent":[".complete-page {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.complete-bg {\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  background: linear-gradient(\n    135deg,\n    #0a0a1a 0%,\n    #1a0a2e 25%,\n    #16213e 50%,\n    #0f3460 75%,\n    #1a0a2e 100%\n  );\n  background-size: 400% 400%;\n  animation: complete-gradient-shift 12s ease infinite;\n}\n\n@keyframes complete-gradient-shift {\n  0%,\n  100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.complete-bg::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 80% 50% at 50% 0%, rgba(255, 215, 0, 0.15) 0%, transparent 50%),\n    radial-gradient(ellipse 60% 40% at 20% 80%, rgba(255, 105, 180, 0.12) 0%, transparent 45%),\n    radial-gradient(ellipse 60% 40% at 80% 70%, rgba(0, 191, 255, 0.12) 0%, transparent 45%);\n  animation: complete-glow-pulse 4s ease-in-out infinite;\n}\n\n@keyframes complete-glow-pulse {\n  0%,\n  100% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n.complete-stars {\n  position: fixed;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.complete-star {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: #fff;\n  border-radius: 50%;\n  animation: complete-star-twinkle 2s ease-in-out infinite;\n  box-shadow: 0 0 6px #fff;\n}\n\n@keyframes complete-star-twinkle {\n  0%,\n  100% {\n    opacity: 0.2;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n}\n\n.complete-canvas {\n  position: fixed;\n  inset: 0;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.complete-confetti-layer {\n  position: fixed;\n  inset: 0;\n  z-index: 3;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.complete-confetti {\n  position: absolute;\n  top: -10%;\n  opacity: 0.9;\n  animation: complete-confetti-fall linear forwards;\n}\n\n@keyframes complete-confetti-fall {\n  0% {\n    transform: translateY(0) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(110vh) rotate(720deg);\n    opacity: 0.6;\n  }\n}\n\n.complete-content {\n  position: relative;\n  z-index: 10;\n  text-align: center;\n  padding: 1.5rem;\n  max-width: 900px;\n  width: 100%;\n}\n\n.complete-logo-wrap {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 1.25rem;\n  padding: 0.5rem;\n  animation: complete-logo-float 3.5s ease-in-out infinite;\n}\n\n.complete-logo-wrap::before {\n  content: \"\";\n  position: absolute;\n  inset: -12%;\n  background: radial-gradient(\n    ellipse at center,\n    rgba(255, 215, 0, 0.12) 0%,\n    rgba(0, 212, 255, 0.06) 40%,\n    transparent 70%\n  );\n  pointer-events: none;\n  z-index: -1;\n}\n\n.complete-logo {\n  display: block;\n  width: clamp(180px, 42vw, 280px);\n  height: auto;\n  max-width: 100%;\n  object-fit: contain;\n  object-position: center;\n  image-rendering: auto;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transform: translateZ(0);\n  filter: drop-shadow(0 12px 40px rgba(0, 0, 0, 0.45))\n    drop-shadow(0 0 48px rgba(255, 215, 0, 0.25))\n    drop-shadow(0 0 24px rgba(0, 212, 255, 0.15));\n}\n\n@keyframes complete-logo-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.complete-title {\n  margin: 0 0 1rem;\n  font-size: clamp(1.5rem, 5.5vw, 3rem);\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: 0.02em;\n  background: linear-gradient(\n    90deg,\n    #ffd700,\n    #fff8dc,\n    #ff6b9d,\n    #00d4ff,\n    #ffd700\n  );\n  background-size: 300% auto;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  animation: complete-title-shine 4s linear infinite;\n  text-shadow: none;\n  filter: drop-shadow(0 0 30px rgba(255, 215, 0, 0.4));\n}\n\n@keyframes complete-title-shine {\n  0% {\n    background-position: 0% center;\n  }\n  100% {\n    background-position: 300% center;\n  }\n}\n\n.complete-subtitle {\n  margin: 0 0 2rem;\n  font-size: clamp(1rem, 3vw, 1.35rem);\n  color: rgba(255, 255, 255, 0.85);\n  font-weight: 400;\n  line-height: 1.6;\n  animation: complete-fade-up 1s ease 0.3s both;\n}\n\n.complete-badge-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: center;\n  animation: complete-fade-up 1s ease 0.6s both;\n}\n\n.complete-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 1.35rem;\n  border-radius: 999px;\n  font-size: clamp(0.8rem, 2.5vw, 0.95rem);\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(8px);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);\n}\n\n.complete-badge::before {\n  content: \"\";\n  flex-shrink: 0;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 10px currentColor;\n}\n\n.complete-badge--gold {\n  color: #ffd700;\n  border-color: rgba(255, 215, 0, 0.5);\n  background: rgba(255, 215, 0, 0.12);\n}\n\n.complete-badge--pink {\n  color: #ff6b9d;\n  border-color: rgba(255, 105, 180, 0.5);\n  background: rgba(255, 105, 180, 0.12);\n}\n\n.complete-badge--cyan {\n  color: #00d4ff;\n  border-color: rgba(0, 212, 255, 0.5);\n  background: rgba(0, 212, 255, 0.12);\n}\n\n.complete-sparkle-ring {\n  position: absolute;\n  width: min(90vw, 500px);\n  height: min(90vw, 500px);\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 2px solid transparent;\n  background: linear-gradient(45deg, transparent, rgba(255, 215, 0, 0.2), transparent) border-box;\n  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);\n  mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  animation: complete-ring-spin 8s linear infinite;\n  pointer-events: none;\n  z-index: -1;\n}\n\n@keyframes complete-ring-spin {\n  from {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n@keyframes complete-fade-up {\n  from {\n    opacity: 0;\n    transform: translateY(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 480px) {\n  .complete-content {\n    padding: 1rem;\n  }\n\n  .complete-badge-row {\n    gap: 0.5rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .complete-bg,\n  .complete-bg::before,\n  .complete-title,\n  .complete-logo-wrap,\n  .complete-star,\n  .complete-confetti,\n  .complete-sparkle-ring {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
